/**
 * A person-typed name for a business or folder: trimmed, non-empty and at
 * most 60 characters. `what` names the thing in the error ("Business",
 * "Folder") so the message reads as the form it came from.
 */
export function validateName(raw: unknown, what: string): string {
  const name = typeof raw === "string" ? raw.trim() : "";
  if (!name) throw new Error(`${what} name cannot be empty`);
  if (name.length > 60) {
    throw new Error(`${what} name must be 60 characters or fewer`);
  }
  return name;
}
